module.exports = __webpack_public_path__ + "media/images/recruit/credo/img-whywedo-6d84ee89e55435e094c6df93a5294870.svg";